
export class MembershipPlanModel {
    public Id : string;
    public Name :string;
    public Title : string;
    public Description : string;
    public NumberOfVenues :string;
    public Price:string;
}